export default "__VITE_ASSET__X0kz9r$O__"